import { z } from "zod";

/**
 * What a traveller wants to be told about, per category. Stored on the same
 * per-user row as the privacy settings; served and patched by
 * /me/notification-preferences. Every key is a plain boolean so a client can
 * patch one switch without knowing the others.
 */
export const notificationPreferencesSchema = z.object({
  /** Confirmations, changes and cancellations of their own bookings. */
  bookingUpdates: z.boolean(),
  /** The nudge before an activity starts. */
  reminders: z.boolean(),
  /** A reply from the concierge to something they asked. */
  conciergeReplies: z.boolean(),
  /** Offers and promotions. The one most travellers switch off. */
  offers: z.boolean(),
  /**
   * Hold back everything except booking changes (reminders, AI replies,
   * offers) while the phone is outside Morocco. Booking confirmations and
   * cancellations always come through.
   */
  onlyInMorocco: z.boolean(),
});
export type NotificationPreferences = z.infer<typeof notificationPreferencesSchema>;

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  bookingUpdates: true,
  reminders: true,
  conciergeReplies: true,
  offers: true,
  onlyInMorocco: false,
};
